'use client'
import Image from 'next/image';
import React, { useRef } from 'react';
import { SwiperRef } from 'antd-mobile/es/components/swiper';
import { Swiper } from 'antd-mobile';

import '@/styles/banner.css'


interface ProductsDetailbannerPropsType{
    Swiperar:string[]
}

function ProductsDetailbanner({Swiperar}:ProductsDetailbannerPropsType){


    const ref = useRef<SwiperRef>(null);

    const items = Swiperar.map((switeritem, index) => (
        <Swiper.Item key={index}>
            <div className="w-[100vw] aspect-[4/3] relative">
    
                    <Image
                        src={switeritem}
                        alt=""
                        fill
                        sizes="100vw"
                        className="w-full h-full object-contain"
                    ></Image>
         
            </div>
        </Swiper.Item>
    ));
    
  return(

    
    <>
         <Swiper
                ref={ref}
                indicatorProps={{
                    style: {
                        '--dot-color': 'rgba(0, 0, 0, 0.2)',
                        '--active-dot-color': '#0195df',
                        '--dot-size': '5px',
                        '--active-dot-size': '5px',
                        '--dot-border-radius': '50%',
                        '--active-dot-border-radius': '15px',
                        '--dot-spacing': '8px',
                    },
                }}
            >
              {items}
            </Swiper>
    </>
  )
}


export default ProductsDetailbanner